import React, { useState } from "react";
import Button from "components/atoms/Button/Button";
import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";
import { FormProvider, useForm } from "react-hook-form";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import { updateInvoicePaymentStatus } from "api";
import errorToast from "helpers/errorToast";
import PAYMENT_STATUS_OPTIONS from "./PaymentStatusOptions";

interface PaymentStatusProps {
  invoiceId: string;
  paymentStatus?: string;
}

interface PaymentStatusFormData {
  [key: string]: string;
}

function PaymentStatus({ invoiceId, paymentStatus }: PaymentStatusProps) {
  const intl = useIntl();
  const methods = useForm();
  const { setValue, handleSubmit } = methods;

  const [isSubmitButtonVisible, setIsSubmitButtonVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSavePaymentStatus = (data: PaymentStatusFormData) => {
    setIsLoading(true);
    updateInvoicePaymentStatus(invoiceId, data)
      .then(() => setIsSubmitButtonVisible(false))
      .catch((err: Error) => errorToast(err))
      .finally(() => setIsLoading(false));
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(handleSavePaymentStatus)}>
        <p className="mb-1 mt-1 font-b3">
          <FormattedMessage id="billing.paymentStatus" defaultMessage="Payment Status" />
        </p>
        <Dropdown
          key={invoiceId}
          options={PAYMENT_STATUS_OPTIONS(intl)}
          onChange={(item: any) => {
            setValue("payment_status", item.value);
            setIsSubmitButtonVisible(true);
          }}
          defaultValue={paymentStatus || ""}
        />
        {isSubmitButtonVisible && (
          <Button
            style={{ marginTop: 8 }}
            className="ml-auto"
            label={intl.formatMessage({
              id: "general.submit",
              defaultMessage: "Submit",
            })}
            isLoading={isLoading}
            variant="primary"
            type="submit"
          />
        )}
      </form>
    </FormProvider>
  );
}

PaymentStatus.propTypes = {
  invoiceId: PropTypes.string.isRequired,
  paymentStatus: PropTypes.string,
};

PaymentStatus.defaultProps = {
  paymentStatus: "",
};

export default PaymentStatus;
